function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { qs } from "scripts/data_utils/domHelpers";
import resizableTextareaHandler from "scripts/dom_utils/resizable_textarea_handler";
import emailValidation from "scripts/data_utils/email_validation";
import formDataFetch from "scripts/data_utils/formDataFetch";
import { throwError } from "scripts/data_utils/throwError";
import PopupPrompt from "./popup_prompt";

class PodFormPopup extends PopupPrompt {
  constructor(el) {
    super(el);

    _defineProperty(this, "body", `
    <div class="modal-wrapper__title">Оставьте свой e-mail</div>
    <p class="modal-wrapper__text modal-wrapper__p">
      Мы&nbsp;свяжемся с&nbsp;вами для уточнения деталей заказа, когда будем готовы напечатать тираж вашей книги.
    </p>
    <form id="dialog_login_form" class="js-form">
      <label for="email" class="text-input">
        <span class="text-input__text">Ваша электронная почта</span>
        <input type="email" id="id_email" name="email" value="${window.app.user.email}" class="text-input__input js-email">
        <div class="modal-wrapper__error js-error-container form-error-email" style="display:none"></div>
      </label>
      <label for="comment" class="text-input">
        <span class="text-input__text">
          Комментарий к заявке <span class="text-input__unrequired">необязатально</span>
        </span>
        <textarea name="comment" id="comment" cols="30" 
        class="text-input__input text-input__textarea js-resizable-textarea js-textarea"></textarea>
      </label>
      <button class="button button--big button--primary js-submit">Оставить заявку</button>
      <div>
        <div class="modal-wrapper__error js-error-container js-__all__ form-error-__all__" style="display:none"></div>
      </div>
    </form>`);

    this.showSuccessPopup = this.showSuccessPopup.bind(this);
    this.validationForm = this.validationForm.bind(this);
    this.sendForm = this.sendForm.bind(this);
    this.init();
    this.form = qs(".js-form", this.dialogBox);
    this.button = qs(".js-submit", this.form);
    this.loader = document.createElement("div");
    this.loader.classList.add("loader-round");
    this.form.addEventListener("submit", this.validationForm);
    this.fields = {
      emailField: qs(".js-email", this.form),
      textArea: qs(".js-textarea", this.form)
    };
    qs(".js-resizable-textarea").addEventListener("keyup", resizableTextareaHandler);
    this.hideErrorOnClickOnField();
  }

  showSuccessPopup() {
    this.bodySelector.classList.add("dialog-show");
    this.dialogBox.innerHTML = `
    <div class="dialog-root" id="dialog-root">
      <div class="dialog-area js-dialog-close"></div>
      <div class="dialog">
        <div class="dialog-inner" id="dialog">
          <div class="modal-wrapper">
            <div class="modal-wrapper__title">Спасибо за ваш интерес</div>
            <p class="modal-wrapper__text modal-wrapper__p">
              Мы свяжемся с вами, как только печать <br>
              тиражей будет запущена. А еще вас будет <br>
              ждать приятный подарок.
            </p>
            <input type="submit" class="button button--big button--default js-dialog-close" value="Хорошо">
          </div>
        </div>
        <span class="dialog-close js-dialog-close"></span>
      </div>
    </div>`;
    this.addHidePopupEventListener();
  }

  sendForm() {
    const url = qs(".js-pod-form-url").value;
    const data = {
      email: this.fields.emailField.value,
      comment: this.fields.textArea.value
    };
    this.disableSubmitButton();
    formDataFetch(url, data).then(() => {
      this.showSuccessPopup();

      if (fbq) {
        fbq("track", "Lead");
      }
    }).catch(error => {
      throwError({
        error
      });
      this.enableSubmitButton();
    });
  }

  validationForm(e) {
    e.preventDefault();

    if (!this.fields.emailField.value) {
      this.showFieldError(this.form, "email", "Введите e-mail");
      return;
    }

    if (!emailValidation(this.fields.emailField.value)) {
      this.showFieldError(this.form, "email", "Не похоже на e-mail");
      return;
    }

    this.sendForm();
  }

}

export default PodFormPopup;